import keycloakAxios from '@/services/axios';
import {Filter} from '@/types/filter';

export const findMyCompanyEvents = async (
  filter: Filter = {},
  direction: -1 | 1 | 'asc' | 'desc' = 'asc'
) => {
  const requestBody = {
    query: {
      ...filter
    },
    sort: [
      {
        key: 'start',
        direction
      }
    ]
  };

  const response = await keycloakAxios.post('company/events/my', requestBody);

  if (response.status >= 300) {
    throw new Error(
      `Error finding company events: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
